import React, { Component, createRef } from 'react';
import axios from 'axios';
import {
  Box,
  TextField,
  Button,
  Typography,
  Table,
  TableBody,InputAdornment,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination
} from '@mui/material';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { Navigate  } from 'react-router-dom';
import Serverurl from './Apiurl';
import searchIcon from './images/SEARCH.png';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

class ServiceQuoteReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      service: '',
      services: [],
      quotes: [],
      totalItems: 0,
      page: 0,
      rowsPerPage: 5
    };
    this.tableRef = createRef();
  }

  componentDidMount() {
	  document.title = "Prep for Sale- Staff Management";
		if(localStorage.getItem("DCuserid")==null)
		  {
		   this.setState({
            logredirect: true,
			pagename:'/'
          })
		  }
    this.fetchServices();
    this.fetchQuotes();
  }

  fetchServices = () => {
    axios
      .get(Serverurl+'servicemanagement/servicemanagementall')
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];
        this.setState({ services: data });
      })
      .catch((err) => console.error('Error fetching services:', err));
  };

  fetchQuotes = () => {
    const { search, service, page, rowsPerPage } = this.state;
    axios
      .get(Serverurl+'requestaquote/search/filter', {
        params: { search, service, page, limit: rowsPerPage }
      })
      .then((res) => {
        this.setState({
          quotes: res.data.data || [],
          totalItems: res.data.totalItems || 0
        });
      })
      .catch((err) => console.error('Error fetching quotes:', err));
  };

  handleSearchChange = (e) => this.setState({ search: e.target.value });
  handleServiceChange = (e) => this.setState({ service: e.target.value });
  handleSearchClick = () => this.setState({ page: 0 }, this.fetchQuotes);
  handleChangePage = (_, newPage) => this.setState({ page: newPage }, this.fetchQuotes);
  handleChangeRowsPerPage = (e) => this.setState({ rowsPerPage: parseInt(e.target.value, 10), page: 0 }, this.fetchQuotes);
  
exportExcel = () => {
  const rows = [];

  this.state.quotes.forEach((q) => {
    rows.push({
      Name: q.rq_name,
      Email: q.rq_emailid,
      Phone: q.rq_phoneno,
      Services: q.rq_sm_id?.map(s => s.sm_title).join(", "),
      Detail: ""
    });

    q.rq_sm_id?.forEach((service) => {
      rows.push({
        Name: "",
        Email: "",
        Phone: "",
        Services: "",
        Detail: `${service.sm_title}`
      });

      (service.answers || []).forEach((ans) => {

        const answerText = ans.details
          ?.filter(d =>
            !/\.(jpg|jpeg|png|gif|webp)$/i.test(d) 
          )
          .join(", ");

        if (answerText && answerText.trim() !== "") {
          rows.push({
            Name: "",
            Email: "",
            Phone: "",
            Services: "",
            Detail: `${ans.type} : ${answerText}`
          });
        }
      });

      rows.push({ Name: "", Email: "", Phone: "", Services: "", Detail: "" });
    });

    rows.push({ Name: "", Email: "", Phone: "", Services: "", Detail: "" });
  });

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(rows);
  XLSX.utils.book_append_sheet(workbook, worksheet, "Request Quotes");
  XLSX.writeFile(workbook, "Request_Quotes.xlsx");
};

  render() {
   if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
    return (
	  	  <div className="maincontentDiv">
        <Typography pt={2} pb={2} className="contentHeading" variant="h5" gutterBottom>
          Requested Quotes Report
        </Typography>

        <Box sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          mb: 2,
          alignItems: 'flex-end'
        }}>
  <Box className="contentSearch" sx={{ display: "flex", flexDirection: "column", width: "230px" }}>
            <Typography variant="body1" sx={{ mb: 0.5 }}>Name / Email / Phone</Typography>
            <TextField
              variant="outlined"
              value={this.state.search}
              onChange={this.handleSearchChange}
              fullWidth
              size="small"
			  placeholder="Search"
			   InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <img
            src={searchIcon} 
            alt="Search"           
          />
        </InputAdornment>
      ),
    }}
            />
          </Box>

          {/* Service Dropdown */}		  
		    <Box sx={{ display: "flex", flexDirection: "column", width: "230px"  }}>
    <Typography variant="body1">Service</Typography>
  <TextField
    select
    variant="outlined"
    size="small"
    value={this.state.service}
              onChange={this.handleServiceChange}
    SelectProps={{ native: true }}
  >
      <Typography variant="body1">Services</Typography>
   <option value="">All</option>
              {this.state.services.map((s) => (
                <option key={s.sm_id} value={s.sm_title}>
                  {s.sm_title}
                </option>))}
  </TextField>
  </Box>

          {/* Buttons */}
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button variant="contained" className="frmPrimarybtn" onClick={this.handleSearchClick}>
              Search
            </Button>

<Button variant="contained" className="frmPrimarybtn" onClick={this.exportExcel}>
  Export
</Button>
          </Box>
        </Box>

        {/* Table */}
        <TableContainer component={Paper}>
          <Table ref={this.tableRef}>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Services</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.quotes.length > 0 ? (
                this.state.quotes.map((q) => (
                  <TableRow key={q.rq_id}>
                    <TableCell>{q.rq_name}</TableCell>
                    <TableCell>{q.rq_emailid}</TableCell>
                    <TableCell>{q.rq_phoneno}</TableCell>
                    <TableCell>
                      {q.rq_sm_id && q.rq_sm_id.length > 0
                        ? q.rq_sm_id.map((s) => s.sm_title).join(', ')
                        : '-'}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          <TablePagination
            component="div"
            count={this.state.totalItems}
            page={this.state.page}
            onPageChange={this.handleChangePage}
            rowsPerPage={this.state.rowsPerPage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 50]}
          />
        </TableContainer>
<Table id="exportTable" style={{ display: "none" }}>
  <TableHead>
    <TableRow>
      <TableCell>Name</TableCell>
      <TableCell>Email</TableCell>
      <TableCell>Phone</TableCell>
      <TableCell>Services</TableCell>
    </TableRow>
  </TableHead>

  <TableBody>
    {this.state.quotes.length > 0 ? (
      this.state.quotes.map((q) => (
        <TableRow key={q.rq_id}>
          <TableCell>{q.rq_name}</TableCell>
          <TableCell>{q.rq_emailid}</TableCell>
          <TableCell>{q.rq_phoneno}</TableCell>

          <TableCell>
            {q.rq_sm_id && q.rq_sm_id.length > 0
              ? q.rq_sm_id.map((s) => s.sm_title).join(", ")
              : "-"}
          </TableCell>
        </TableRow>
      ))
    ) : (
      <TableRow>
        <TableCell colSpan={4}>No records found</TableCell>
      </TableRow>
    )}
  </TableBody>
</Table>
      </div>
    );
  }
}

export default ServiceQuoteReport;
